export default __webpack_public_path__ + "static/media/640_business08-jp-mobile.b6280ff3.png";